import React from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { HomepageGlobalStyles } from "../Homepage/styles";
import PostDetailCore from "./PostDetailCore";
import { PostDetailPage } from "./PostDetail.styles";

/**
 * Lovable shell for post detail. All prod behavior lives in PostDetailCore
 * (API, gating, Wistia, comments, likes/favorites, share, public access, suggested posts).
 */
const PostDetail = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  return (
    <PostDetailPage className="post-detail-page">
      <HomepageGlobalStyles />
      <Header onSubscribeClick={goToPricing} hideSpacer />
      <PostDetailCore />
      <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
    </PostDetailPage>
  );
};

export default PostDetail;
